import { createContext, useContext } from 'react';
export const TrainContext = createContext(null);
export function useTrainContext() {
    const ctx = useContext(TrainContext);
    if (!ctx) {
        throw new Error('useTrainContext must be used within a <TrainProvider>');
    }
    return ctx;
}
